import { API_URL, CLIENT_API } from '../common/Constant.js';
import Http from './Http.js';
export default class API {
  constructor(store) {
    this.store = store;
  }

  getAuth() {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.request(API_URL.GET_AUTH);
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }

  createDemand(params) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.request(API_URL.CREAT_DEMAND, params);
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }

  createSubtitle(params) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.request(API_URL.CREAT_SUBTITLE, params);
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }

  checkFile(params) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.request(CLIENT_API.QUERY_FILE, params, 'GET');
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }

  uploadFile(params, timeout) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      try {
        // 上传接口会比较久，超时设置为更长的长度
        http.xmlhttp.timeout = timeout || 120000;
      } catch (orz) {
        /**/
      }
      http.request(CLIENT_API.UPLOAD_FILE, params);
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }

  deleteFile(params) {
    return new Promise((resolve, reject) => {
      const http = new Http(this.store);
      http.request(CLIENT_API.DELET_FILE, params);
      http.onLoad = e => resolve(e);
      http.onError = e => reject(e);
    });
  }
}
